"use client";
import { List, ListItem, Stack, Typography } from "@mui/material";
import React from "react";

const TableOfContents = () => {
  const TableOfContentsData = [
    { title: "Loan Requests", link: "#loan-request" },
    { title: "Use License", link: "#use-license" },
    { title: "Social Media", link: "#social-media" },
    { title: "Submissions", link: "#submissions" },
    { title: "Links to other websites", link: "#links-to-other-websites" },
    { title: "User Consent", link: "#user-consent" },
    {
      title: "Terms of use of our services",
      link: "#terms-of-use-of-our-services",
    },
    {
      title: "Use of Information and Materials",
      link: "#use-of-information-and-materials",
    },
    { title: "Prohibited Conduct", link: "#prohibited-conduct" },
    { title: "Obligation of users", link: "#obligation-of-users" },
    { title: "Availability of Service", link: "#availability-of-service" },
    { title: "Devices and Software", link: "#devices-and-software" },
    { title: "Fees and Taxes", link: "#fees-and-taxes" },
    {
      title: "Intellectual Property Rights",
      link: "#intellectual-property-rights",
    },
    {
      title: "Privacy Policy and User Data",
      link: "#privacy-policy-and-user-data",
    },
    {
      title: "Acceptable use of our services",
      link: "#acceptable-use-of-our-services",
    },
    {
      title: "Legal and Acceptable Use",
      link: "#legal-and-acceptable-use",
    },
    {
      title: "Indemnification",
      link: "#indemnification",
    },
    {
      title: "Cookies",
      link: "#cookies",
    },
    {
      title: "No representation or warranty",
      link: "#no-representation-or-warranty",
    },
    {
      title: "User Data",
      link: "#user-data",
    },
    {
      title: "Amendments",
      link: "#amendments",
    },
    {
      title: "Breach of the Terms",
      link: "#breach-of-the-terms",
    },
    {
      title: "Electronic Communications, Transactions, and Signatures",
      link: "#electronic-communications-transactions-and-signatures",
    },
    {
      title: "Governing Law and Jurisdiction",
      link: "#governing-law-and-jurisdiction",
    },
    {
      title: "Dispute Resolution",
      link: "#dispute-resolution",
    },
    {
      title: "Disclaimer",
      link: "#disclaimer",
    },
    {
      title: "Limitation of Liability",
      link: "#limitation-of-liability",
    },
    {
      title: "Severability",
      link: "#severability",
    },
    {
      title: "User Accptance",
      link: "#user-acceptance",
    },
    {
      title: "Contact Us",
      link: "#contact-us",
    },
    {
      title: "Grienvance Redressal Mechanism",
      link: "#grievance-redressal-mechanism",
    },
  ];

  const handleSmoothScroll = (link) => {
    const targetElement = document.querySelector(link);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Stack gap={2} sx={{ padding: { xs: 2, sm: 4 } }}>
      <Typography
        fontSize={{ xs: "1.5rem", sm: "1.75rem" }}
        fontWeight={500}
        textTransform={"uppercase"}
      >
        Table Of Contents
      </Typography>
      <List sx={{ listStyleType: "decimal" }}>
        {TableOfContentsData.map((item, index) => (
          <ListItem
            sx={{ display: "list-item", fontSize: 14, py: { xs: 0.5, sm: 1 } }}
            key={index}
          >
            <span
              style={{
                textDecoration: "underline",
                color: "#0d6efd",
                cursor: "pointer",
                textTransform: "uppercase",
              }}
              onClick={() => handleSmoothScroll(item.link)}
            >
              {item.title}
            </span>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
};

export default TableOfContents;
